import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
                <i className="ri-bar-chart-2-line"></i>
                实时榜单
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
                热度榜单
              </h2>
            </div>
            <div className="hidden sm:flex items-center gap-1 text-xs text-foreground-400">
              <span>每小时更新</span>
              <i className="ri-information-line"></i>
            </div>
          </div>

          <div className="bg-background-50 border border-background-200 rounded-xl overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={item.id}
                className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors cursor-pointer ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200' : ''
                }`}
              >
                <div className={`flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center text-sm font-bold ${
                  idx === 0
                    ? 'bg-primary-500 text-background-50'
                    : idx === 1
                    ? 'bg-accent-500 text-background-50'
                    : idx === 2
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-100 text-foreground-500'
                }`}>
                  {idx + 1}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="font-sans text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                </div>

                <div className="flex items-center gap-3 flex-shrink-0">
                  <div className="text-right">
                    <div className="text-sm font-bold text-primary-600">{item.heat}</div>
                    <div className={`text-xs flex items-center gap-0.5 ${
                      item.change === 'up' ? 'text-primary-500' : item.change === 'down' ? 'text-foreground-400' : 'text-secondary-600'
                    }`}>
                      <i className={`text-xs ${item.change === 'up' ? 'ri-arrow-up-line' : item.change === 'down' ? 'ri-arrow-down-line' : 'ri-subtract-line'}`}></i>
                      {item.changeNum}
                    </div>
                  </div>
                  <i className="ri-arrow-right-s-line text-foreground-300"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}